import { Box, Checkbox, CircularProgress } from "@mui/material";
import { Link } from "react-router-dom";
import LinkIcon from "@mui/icons-material/Link";
import { useMessages } from "./MessagesContext";
import { DataGrid } from "@mui/x-data-grid";


const isActiveMessage=(message)=>{
    if(message.expirationDate === null || new Date(message.expirationDate) >new Date()){
        return true
    }
    else    
        return false
}

const MessagesList =()=>{
    const { messages, setSelectedMessage, setSelectedMessageLog } =
        useMessages();

    const viewEditLinkIcon = (item) => {
      return (
                <Link  className="hyper-links" onClick={(e)=>{setSelectedMessage(item)}}>
                    {item.id}
                </Link>
            )
    }

    const messageLogLink = (item) => {
        return (
            <Link
                style={{ textDecoration: "none" }}
                className="hyper-links"
                onClick={(e) => {
                setSelectedMessageLog(item);
                }}
            >
                <LinkIcon fontSize="medium"  sx={{alignItems:'center'}}/>
            </Link>
        )
    }

    const convertDateISOToUTC = (isoDate) => {
        if( isoDate !==null && isoDate !=="") {
            const date = new Date(isoDate);
            const utcFormatted = `${date.getUTCFullYear()}-${String(date.getUTCMonth()+1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')} ${String(date.getUTCHours()).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(2, '0')}:${String(date.getUTCSeconds()).padStart(2, '0')}`;
            return utcFormatted
        } 
        else return ""; 
    }

    const dataGridColumns =[
        { field:'id', headerName:'Id', filterable:true, sortable:true, renderCell:(params) => viewEditLinkIcon(params.row) },
        { field:'text', headerName:'Text', filterable:true, sortable:false, width:1000, renderCell:(params)=>{
                return <div style={{whiteSpace:'normal', lineHeight:'1.2em', wordWrap:'break-word', overflowWrap:'break-word'}}><span  dangerouslySetInnerHTML={{ __html: params.row.text}}></span> </div>
            }
        },
        { field:'priority', headerName:'Priority', filterable:true, sortable:true, width:100 },
        { field:'active', headerName:'Active', filterable:false, sortable:false, renderCell:(params)=>
            <Checkbox disabled checked={isActiveMessage(params.row)}></Checkbox>
        },
        { field:'expirationDate', headerName:'Expiration Date', filterable:true, sortable:true, width:200, renderCell:(params) => convertDateISOToUTC(params.row.expirationDate) },
        { field:'logs', headerName:'Logs', filterable:false, sortable:false, renderCell:(params) => messageLogLink(params.row) }
             
    ]
    
    if(messages!== null && messages.length > 0){
        return(
        <>
            <DataGrid rows={messages} columns={dataGridColumns} disableSelectionOnClick sx={{'& .MuiDataGrid-columnHeaders':{ fontSize:'1rem',fontWeight:'bold',display:'flex'}}}/>
        </>
        )
    } 
    else 
        return (
        <Box sx={{ width: "100%", textAlign: "center" }}>
            <CircularProgress/>
         </Box>)
    }  
    
    export default MessagesList;
        
        